import { Vue } from 'vue-property-decorator';

import userService from '@/services/user.service';
import errorsService from '@/services/errors.service';
import accountService from '@/services/account.service';

import { ITokenModel } from '@/models/token.model';
import { ITwitchCallbackRequestModel, ITwitchCallbackResultModel, ITwitchUnlinkResultModel } from '../models/twitch.model';

export default {
  goToTwitch(context: Vue, redirectUrl?: string): void {
    context.$store.dispatch("updateIsLinkingTwitchLoading", true);
    context.$store.dispatch("updateIsLoading", true);

    let url: string = context.$data.RCEnvironment.VUE_APP_ACCOUNT_API_URL + "twitch/auth?callbackPath=/twitch/callback";
    if (redirectUrl != null) {
      url += "?redirectUrl=" + redirectUrl;
    }

    accountService.get<string>(context, url)
      .then(response => {
        context.$store.dispatch("updateIsLinkingTwitchLoading", false);
        context.$store.dispatch("updateIsLoading", false);
        window.location.href = response;
      })
      .catch(error => {
        context.$store.dispatch("updateIsLinkingTwitchLoading", false);
        context.$store.dispatch("updateIsLoading", false);
        errorsService.handleErrors(context, error);
      });
  },

  callbackTwitch(context: Vue, model: ITwitchCallbackRequestModel, token: ITokenModel): void {
    context.$store.dispatch("updateIsLinkingCallbackLoading", true);
    context.$store.dispatch("updateIsLinkingTwitchLoading", true);
    context.$store.dispatch("updateIsLoading", true);

    const url: string = context.$data.RCEnvironment.VUE_APP_ACCOUNT_API_URL + "twitch/callback";

    accountService.post<ITwitchCallbackRequestModel, ITwitchCallbackResultModel>(context, url, model, { headers: { Authorization: "Bearer " + token.Value } })
      .then(async () => {
        const redirectUrl = context.$store.getters.redirectUrl;

        context.$store.dispatch("updateIsLinkingCallbackLoading", false);
        context.$store.dispatch("updateIsLinkingTwitchLoading", false);
        userService.updateUser(context, redirectUrl != null, true);
      })
      .catch(error => {
        context.$store.dispatch("updateIsLinkingCallbackLoading", false);
        context.$store.dispatch("updateIsLinkingTwitchLoading", false);
        context.$store.dispatch("updateIsLoading", false);

        errorsService.handleErrors(context, error);
      });
  },

  unlinkTwitch(context: Vue, token: ITokenModel) {
    context.$store.dispatch("updateIsLinkingTwitchLoading", true);
    context.$store.dispatch("updateIsLoading", true);

    const url: string = context.$data.RCEnvironment.VUE_APP_ACCOUNT_API_URL + "twitch/unlink";

    accountService.post<object, ITwitchUnlinkResultModel>(context, url, {}, { headers: { Authorization: "Bearer " + token.Value } })
      .then(() => {
        context.$store.dispatch("updateIsLinkingTwitchLoading", false);
        context.$store.dispatch("updateIsLoading", false);

        const redirectUrl = context.$store.getters.redirectUrl;

        if (redirectUrl != null) {
          window.location.href = redirectUrl;
          return;
        }

        userService.updateUser(context, redirectUrl != null, true);
      })
      .catch(error => {
        context.$store.dispatch("updateIsLinkingTwitchLoading", false);
        context.$store.dispatch("updateIsLoading", false);
        errorsService.handleErrors(context, error);
      });
  }
}